export enum SwitchBulkSetting {
  PrintId = "PrintId",
  Frame = "Frame",
  Coupon = "Coupon",
  SerialNumber = "SerialNumber",
  Logo = "Logo"
}
